module.exports = __webpack_public_path__ + "img/stereoscopic_cam3.6193cc58.jpg";